webpackJsonp([2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(28);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

	"use strict";

	// $(function () {
	//   var $mod = $('.module-header');
	//   var ru = $mod.data('ru') || '';
	//   var hostName = /focustest/.test(location.host) ? 'focustest' : 'focus';
	//   $mod.find('.btn-open-signup').attr('href', '//login.' + hostName + '.cn/w/reg?ru=' + ru);
	//   // 通知login模块 打开弹窗
	//   $mod.find('.btn-open-login .txt').on('click', function () {
	//     $(document).trigger('login-open', {});
	//   });
	//
	//   // 接收其他模块通信
	//   function loginSuccess(data) {
	//     $mod.find('.unlog-wrap').hide();
	//     $mod.find('.loged-wrap').show();
	//     $mod.find('.loged-wrap').find('.btn-info .txt').text(data);
	//     $mod.find('.loged-wrap').find('.btn-logout').click(function () {
	//       $(document).trigger('login-out', {});
	//     });
	//   }
	//
	//   $(document).on('login-getUserInfo-success', function (e, data) {
	//     loginSuccess(data);
	//   });
	//
	//   $(document).on('login-success', function (e, data) {
	//     loginSuccess(data);
	//   });
	//
	// });

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	__webpack_require__(8);
	
	__webpack_require__(10);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(23);
	
	__webpack_require__(29);
	__webpack_require__(38);
	__webpack_require__(17);
	__webpack_require__(19);

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	*** todo: 历史原因，代码亟待优化
	**/
	
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _modelPassportJs = __webpack_require__(39);
	
	var _modelPassportJs2 = _interopRequireDefault(_modelPassportJs);
	
	var _assetsLibMd5Js = __webpack_require__(43);
	
	var _assetsLibMd5Js2 = _interopRequireDefault(_assetsLibMd5Js);
	
	var _error = __webpack_require__(44);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _helper = __webpack_require__(45);
	
	__webpack_require__(46);
	
	$(function () {
	    var $mod = $('.module-passport-passwd');
	    var sendVerifyEmailCb;
	    var count = 60;
	
	    var FCAbroadMobile1 = new window.FCAbroadMobile({
	        domain: 'findpwd',
	        ctn: '[node-type="pass-container"] .tel-wrap',
	        width: 280
	    });
	    var tel = FCAbroadMobile1.$input;
	
	    var valid = {
	        captcha: true,
	        submit: true
	    };
	
	    var refreshCode = function refreshCode() {
	        var href = $('#validateCode').attr('src') + '?t=' + new Date().getTime();
	        $('#validateCode').attr('src', href);
	    };
	    var Event = {
	        isSubmit: function isSubmit(ok, obj) {
	            var temp = 0,
	                i;
	
	            for (i = 0; i < ok.length; i++) {
	                if (ok[i] === 1 || ok[i] === 0) {
	                    temp = 1;
	                }
	            }
	            if (temp === 0) {
	                obj.removeClass('disabled');
	            } else {
	                obj.addClass('disabled');
	            }
	        },
	        MobileStep1: function MobileStep1() {
	            var val,
	                error = new _error2['default'](),
	                getCode = $mod.find('.get-code-btn'),
	                that = this,
	                codeBtn = $mod.find('.code-info-btn'),
	                i = 60,
	                timer,
	                ok = [0, 0, 0];
	
	            //获取验证码
	            getCode.click(function (event) {
	
	                var _self = $(this),
	                    val = $.trim(tel.val()),
	                    captcha = $mod.find('input[node-type=mobile-picValidate]'),
	                    capVal = $.trim(captcha.val());
	                if (!valid.captcha) {
	                    return;
	                }
	
	                valid.captcha = false;
	                setTimeout(function () {
	                    valid.captcha = true;
	                }, 1000);
	                //判断手机号
	                if (!FCAbroadMobile1.check()) {
	                    error.show(tel, error.ErrorTxt[0]);
	                    return;
	                }
	                if (_helper.Validate.isEmpty(capVal)) {
	                    error.show(captcha, error.ErrorTxt[13]);
	                    return;
	                }
	
	                //发送ajax请求，成功后回调到这里
	                _modelPassportJs2['default'].getMobileCaptcha({
	                    mobile: val,
	                    type: 5,
	                    imgcode: capVal,
	                    channel: 0,
	                    cacode: FCAbroadMobile1.getCode()
	
	                }, function (data) {
	
	                    if (data.errorCode === 0) {
	                        getCode.hide().attr('attr-on', '1');
	
	                        codeBtn.html(i + 's后重试').show();
	                        var timer = window.setInterval(function () {
	                            i--;
	                            codeBtn.html(i + 's后重试');
	                            if (i <= 0) {
	                                window.clearInterval(timer);
	                                codeBtn.hide();
	                                getCode.show();
	                                i = 60;
	                            }
	                        }, 1000);
	                    } else if (data.errorCode === 6) {
	                        refreshCode();
	                        error.show(captcha, data.errorMessage);
	                    } else {
	                        refreshCode();
	                        window.alert(data.errorMessage);
	                    }
	                });
	            });
	
	            function checkMobile() {
	                var val = $.trim(tel.val());
	
	                if (!FCAbroadMobile1.check()) {
	                    error.show(tel, error.ErrorTxt[0]);
	                    ok[0] = 1;
	                    this.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	                    return;
	                }
	                ok[0] = 2;
	                error.hide(tel);
	                this.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	            }
	
	            //手机号
	            $mod.find('.FCMobile-wrap_findpwd').on('input propertychange', function () {
	                checkMobile.apply(that);
	            });
	
	            tel.on('FCMobile_SELECT', function (e, d) {
	                checkMobile.apply(that);
	            });
	
	            //图片验证码
	            $mod.find('input[node-type=mobile-picValidate]').on('input propertychange', function () {
	                val = $.trim($(this).val());
	                if (_helper.Validate.isEmpty(val)) {
	                    error.show($(this), error.ErrorTxt[13]);
	                    ok[1] = 1;
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	                    return;
	                }
	                ok[1] = 2;
	                error.hide($(this));
	                that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	            });
	            //手机验证码
	            $mod.find('input[node-type=mobile-telValidate]').on('input propertychange', function () {
	                val = $.trim($(this).val());
	
	                if (_helper.Validate.isEmpty(val) || $.trim(val).length !== 6) {
	                    error.show($(this), error.ErrorTxt[6]);
	                    ok[2] = 1;
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	                }
	                ok[2] = 2;
	                error.hide($(this));
	                that.isSubmit(ok, $mod.find('a[node-type=mobile-step1]'));
	            });
	        },
	        emailStep1: function emailStep1() {
	            var val,
	                error = new _error2['default'](),
	                that = this,
	                ok = [0];
	
	            $mod.find('input[node-type=email-input]').on('input propertychange', function () {
	                val = $.trim($(this).val());
	                var _self = $(this);
	                if (!_helper.Validate.isEmail(val)) {
	                    error.show(_self, error.ErrorTxt[12]);
	                    ok[0] = 1;
	                    that.isSubmit(ok, $mod.find('a[node-type=email-step1]'));
	                    return;
	                }
	                ok[0] = 2;
	                error.hide(_self);
	                that.isSubmit(ok, $mod.find('a[node-type=email-step1]'));
	            });
	        },
	        setPass: function setPass() {
	            var val,
	                error = new _error2['default'](),
	                ok = [0, 0],
	                pswd1,
	                pswd2,
	                that = this;
	            var pswd1Input = $mod.find('input[node-type=\'passport-pass1\']'),
	                pswd2Input = $mod.find('input[node-type=\'passport-pass2\']');
	
	            function pass1cb(input) {
	                return function () {
	                    // 只要改了，先把按钮置灰
	                    ok[0] = 1;
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                    val = input.val();
	                    var levelInfo = _helper.Validate.pwdLevel(val),
	                        level = levelInfo.length,
	                        safei = $mod.find('.safe-tip i');
	                    safei.removeClass('cur');
	                    // 至少8位密码，包括大写、小写、数字、特殊字符中的三种即可
	                    // 使用正则匹配
	                    var pwReg = new RegExp(/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/);
	                    if (!pwReg.test(val)) {
	                        error.show(input, error.ErrorTxt[15]);
	                        return false;
	                    }
	
	                    if (level === 3) {
	                        safei.addClass('cur');
	                    } else if (level === 2) {
	                        safei.eq(0).addClass('cur');
	                        safei.eq(1).addClass('cur');
	                    } else if (level === 1) {
	                        safei.eq(0).addClass('cur');
	                        if (levelInfo[0] === 'd') {
	                            error.show(input, error.ErrorTxt[11]);
	                            ok[0] = 1;
	                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                            return;
	                        }
	                    }
	                    ok[0] = 2;
	                    pswd2 = pswd2Input.val();
	                    if (val.length >= 8 && val.length < 16) {
	                        if (pswd2) {
	                            error.hide($mod.find('input[node-type=\'passport-pass2\']'), error.ErrorTxt[10]);
	
	                            if (val !== pswd2) {
	                                error.show(input, error.ErrorTxt[10]);
	                                ok[0] = 1;
	                                that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                                return;
	                            } else {
	                                ok[0] = 2;
	                                ok[1] = 2;
	                                error.hide(input);
	                                error.hide($mod.find('a[node-type=mobile-step2]'));
	                            }
	                        } else {
	                            error.hide(input);
	                        }
	                    } else {
	                        error.show(input, error.ErrorTxt[8]);
	                        ok[0] = 1;
	                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                        return;
	                    }
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                };
	            }
	
	            function pass2cb(input) {
	                return function () {
	                    // 只要改了，先把按钮置灰
	                    ok[0] = 1;
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                    val = input.val();
	                    pswd1 = pswd1Input.val();
	                    var levelInfo = _helper.Validate.pwdLevel(val),
	                        level = levelInfo.length;
	                    // 至少8位密码，包括大写、小写、数字、特殊字符中的三种即可
	                    // 使用正则匹配
	                    var pwReg = new RegExp(/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/);
	                    if (!pwReg.test(val)) {
	                        error.show(input, error.ErrorTxt[15]);
	                        return false;
	                    }
	                    if (pswd1.length < 8 || pswd1.length >= 16) {
	                        error.show(pswd1Input, error.ErrorTxt[8]);
	                        ok[0] = 1;
	                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                        return;
	                    }
	                    if (val.length <= 0) {
	                        error.show(input, error.ErrorTxt[14]);
	                        ok[1] = 1;
	                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                        return;
	                    }
	
	                    if (pswd1) {
	                        error.hide(pswd1Input, error.ErrorTxt[10]);
	                        if (val !== pswd1) {
	                            error.show(input, error.ErrorTxt[10]);
	                            ok[1] = 1;
	                            that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                            return;
	                        } else {
	                            ok[0] = 2;
	                            ok[1] = 2;
	                            error.hide(input);
	                            error.hide($mod.find('a[node-type=mobile-step1]'));
	                        }
	                    }
	
	                    if (level === 1 && levelInfo[0] === 'd') {
	                        error.show(input, error.ErrorTxt[11]);
	                        ok[1] = 1;
	                        that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                        return;
	                    }
	
	                    ok[1] = 2;
	                    that.isSubmit(ok, $mod.find('a[node-type=mobile-step2]'));
	                };
	            }
	            if (navigator.appName == 'Microsoft Internet Explorer' && navigator.appVersion.match(/9./i) == '9.') {
	                pswd1Input[0].attachEvent('oninput', pass1cb(pswd1Input));
	                pswd2Input[0].attachEvent('oninput', pass2cb(pswd2Input));
	
	                pswd1Input[0].attachEvent('onkeyup', function (e) {
	                    if (e.keyCode === 8) {
	                        //删除--触发
	                        pswd1Input[0].fireEvent('oninput');
	                    }
	                });
	                pswd2Input[0].attachEvent('onkeyup', function (e) {
	                    if (e.keyCode === 8) {
	                        //删除--触发
	                        pswd2Input[0].fireEvent('oninput');
	                    }
	                });
	            }
	
	            pswd1Input.on('input propertychange', pass1cb(pswd1Input));
	
	            //确认密码
	            pswd2Input.on('input propertychange', pass2cb(pswd2Input));
	        }
	    };
	
	    var Form = function Form() {
	        this.state = 11;
	        this.renderHtml = _helper.renderHtml;
	    };
	
	    Form.prototype = {
	        init: function init() {
	            // 发送邮件回来要显示
	            var emailToken = $mod.find('input[node-type=token]').val(),
	                validToken = $mod.find('input[node-type=validToken]').val();
	            if (emailToken !== '') {
	                if (validToken === '-1') {
	                    this.state = 25;
	                } else {
	                    this.state = 23;
	                }
	            }
	
	            this.action();
	
	            this.event();
	        },
	
	        event: function event() {
	            var error = new _error2['default'](),
	                that = this,
	                telCtn = $mod.find('#phone_getback'),
	                mailCtn = $mod.find('#mail_getback'),
	                state;
	
	            $('#validateCode').click(function () {
	                refreshCode();
	            });
	            $mod.find('.type-menu').on('click', 'a', function () {
	                var curTabItem = $(this);
	                if (curTabItem.hasClass('cur')) {
	                    return;
	                }
	                var index = curTabItem.index();
	                $mod.find('.type-menu a.cur').removeClass('cur');
	                curTabItem.addClass('cur');
	
	                if (!that.save_state) {
	                    that.save_state = that.state;
	                }
	                that.tmp = that.state;
	
	                if (index === 0) {
	                    if (that.save_state > 20) {
	                        that.state = 11;
	                    } else that.state = that.save_state;
	                } else if (index === 1) {
	                    if (that.save_state < 20) {
	                        that.state = 21;
	                    } else that.state = that.save_state;
	                }
	                that.action(true);
	                that.save_state = that.tmp;
	            });
	
	            //input表格获取焦点 错误提示消息
	            $mod.delegate('input', 'focus', function (event) {
	                error.hide($(this));
	            });
	
	            //邮箱修改回调
	            sendVerifyEmailCb = function (data) {
	
	                if (data.errorCode === 0) {
	                    that.state = state || 22;
	                    $mod.find('input[node-type=email]').val(data.data.email);
	                    $mod.find('input[node-type=userName]').val(data.data.userName);
	                    that.action();
	                } else {
	                    window.alert(data.errorMessage);
	                }
	            };
	            //完成验证后的动作
	            $mod.delegate('.submit-btn', 'click', function (event) {
	
	                if (!valid.submit) {
	                    return;
	                }
	
	                valid.submit = false;
	                setTimeout(function () {
	                    valid.submit = true;
	                }, 1000);
	                state = parseInt($(this).attr('next-step'), 10);
	                switch (state) {
	                    case 12:
	                        var mobile = $.trim(FCAbroadMobile1.$input.val()),
	                            captcha = $.trim($mod.find('input[node-type=mobile-telValidate]').val());
	
	                        if (!$(this).hasClass('disabled')) {
	                            _modelPassportJs2['default'].passwordVerifyCaptcha(mobile, captcha, FCAbroadMobile1.getCode(), function (data) {
	                                if (data.errorCode === 0) {
	                                    that.state = state;
	                                    that.mobileToken = data.data.token;
	                                    that.action();
	                                } else if (data.errorCode === 1) {
	                                    error.show($mod.find('input[node-type=mobile-telValidate]'), error.ErrorTxt[6]);
	                                } else {
	                                    window.alert(data.errorMessage);
	                                }
	                            });
	                        }
	                        break;
	                    case 13:
	                        if (!$(this).hasClass('disabled')) {
	                            _modelPassportJs2['default'].resetByMobile(that.mobileToken || '', (0, _assetsLibMd5Js2['default'])($mod.find('input[node-type=passport-pass1]').val()), function (data) {
	                                if (data.errorCode === 0) {
	                                    that.state = state;
	                                    that.action();
	                                } else {
	                                    window.alert(data.errorMessage);
	                                }
	                            });
	                        }
	                        break;
	                    case 22:
	                        if (!$(this).hasClass('disabled')) {
	                            _modelPassportJs2['default'].sendVerifyEmail($.trim($mod.find('input[node-type=email-input]').val()), '1', sendVerifyEmailCb);
	                        }
	                        break;
	                    case 24:
	                        if (!$(this).hasClass('disabled')) {
	                            _modelPassportJs2['default'].resetByEmail($mod.find('input[node-type=token]').val(), (0, _assetsLibMd5Js2['default'])($mod.find('input[node-type=passport-pass1]').val()), function (data) {
	                                if (data.errorCode === 0) {
	                                    that.state = state;
	                                    that.action();
	                                } else {
	                                    window.alert(data.errorMessage);
	                                }
	                            });
	                        }
	                        break;
	                }
	            });
	        },
	        action: function action(stop) {
	            var that = this,
	                num,
	                menu,
	                telCtn = $mod.find('#phone_getback'),
	                mailCtn = $mod.find('#mail_getback'),
	                state = that.state;
	            $mod.find('.type-menu a').removeClass('cur');
	
	            if (this.state > 20) {
	                $($mod.find('.type-menu a')[1]).addClass('cur');
	                menu = $('#mail_getback');
	                telCtn.hide();
	                mailCtn.show();
	            } else {
	                $($mod.find('.type-menu a')[0]).addClass('cur');
	                menu = $('#phone_getback');
	                mailCtn.hide();
	                telCtn.show();
	            }
	
	            menu.find('li').each(function (index) {
	                var arr = this.className.split('-');
	                num = parseInt(state, 10) % 10;
	                if (num > index) {
	                    this.className = arr[0] + '-' + 'done';
	                } else {
	                    this.className = arr[0] + '-' + 'todo';
	                }
	            });
	            switch (this.state) {
	                case 11:
	                    Event.MobileStep1();
	                    break;
	                case 23:
	                    menu.find('div[node-type=pass-container]').html(this.renderHtml[0]);
	                    Event.setPass();
	                    menu.find('.submit-btn').attr('next-step', 24);
	                    break;
	                case 12:
	                    menu.find('div[node-type=pass-container]').html(this.renderHtml[0]);
	                    Event.setPass();
	                    menu.find('.submit-btn').attr('next-step', 13);
	                    break;
	                case 21:
	                    Event.emailStep1();
	                    break;
	                case 22:
	                    var email = $mod.find('input[node-type=email]').val() || $.trim($mod.find('input[node-type=email-input]').val());
	                    var userName = $mod.find('input[node-type=userName]').val() || email;
	                    this.email = email;
	                    menu.find('div[node-type=pass-container]').html(this.renderHtml[1]);
	                    menu.find('.sended-mail').html(this.hiddenMail(email));
	                    //前入立即验证
	                    $('.goto-mail-btn').on('click', function () {
	
	                        var url = email.split('@')[1];
	                        window.location.href = _helper.mailMap[url];
	                    });
	
	                    this.countDown(stop);
	
	                    //重新发送
	                    $('.s-z-container').on('click', '.resend', function (event) {
	                        count = 60;
	                        var userName = $mod.find('input[node-type=userName]').val() || $mod.find('input[node-type=email-input]').val();
	                        _modelPassportJs2['default'].sendVerifyEmail($.trim(userName), '1', sendVerifyEmailCb);
	                    });
	                    break;
	                case 13:
	                case 24:
	                    menu.find('div[node-type=pass-container]').html(this.renderHtml[2]);
	                    break;
	                case 25:
	                    menu.find('div[node-type=pass-container]').html(this.renderHtml[3]);
	                    //重新发送
	                    $('.resend').click(function (event) {
	                        event.preventDefault();
	                        var userName = $mod.find('input[node-type=userName]').val() || $mod.find('input[node-type=email-input]').val();
	                        _modelPassportJs2['default'].sendVerifyEmail($.trim(userName), '1', sendVerifyEmailCb);
	                    });
	                    break;
	            }
	        },
	        // 倒计时60s, 到期显示重新发送
	        countDown: function countDown(stop) {
	
	            var msgWrap = $('.send-msg-wrap'),
	                autotimer;
	
	            msgWrap.html('已发送<b><i class="time-count">' + count + '</i>s</b>后重新发送');
	            if (stop) {
	                return;
	            }
	
	            autotimer = window.setInterval(function () {
	                count--;
	                if (count === 0) {
	                    window.clearInterval(autotimer);
	                    msgWrap.html('没收到邮件？<b class="resend">请重新发送</b>');
	                    msgWrap.removeClass('disabled');
	                    return;
	                }
	                $('.time-count').html(count);
	            }, 1000);
	        },
	        hiddenMail: function hiddenMail(mail) {
	            return mail.replace(/^(.*?)(.{0,4})@/, function ($, $1) {
	                return $1 + '****@';
	            });
	        }
	    };
	    var form = new Form();
	    form.init();
	});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $$request = __webpack_require__(40);
	var proxy = __webpack_require__(41);
	
	module.exports = {
	    //通过手机注册
	    regByMobile: function regByMobile(data, fn) {
	        var _this = this;
	        var params = {
	            mobile: data.mobile,
	            captcha: data.captcha,
	            password: data.password,
	            imgcode: data.imgcode,
	            channel: data.channel,
	            cacode: data.cacode || ''
	
	        };
	
	        proxy('regByMobile', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //通过账号注册
	    regByEmail: function regByEmail(data, fn) {
	        var _this = this;
	        var params = {
	            email: data.email,
	            password: data.password,
	            appId: data.appId,
	            nick: data.nick,
	            source: data.source
	        };
	
	        proxy('regByEmail', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //账号登录
	    loginByPassport: function loginByPassport(data, fn) {
	        var _this = this;
	        var params = {
	            passport: data.passport,
	            password: data.password,
	            auto: data.auto,
	            imgcode: data.imgcode,
	            channel: data.channel //个人中心传5，生态传12
	        };
	
	        proxy('loginByPassport', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //手机号登录
	    loginByCaptcha: function loginByCaptcha(data, fn) {
	        var _this = this;
	        var params = {
	            mobile: data.mobile,
	            captcha: data.captcha,
	            auto: data.auto,
	            imgcode: data.imgcode,
	            channel: data.channel
	        };
	
	        proxy('loginByCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //检查邮箱是否可用
	    regCheck: function regCheck(email, fn) {
	        var _this = this;
	        var params = {
	            email: email
	        };
	
	        proxy('regCheck', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //查询手机号是否被注册
	    mobileHasBind: function mobileHasBind(mobile, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile
	        };
	
	        proxy('mobileHasBind', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //查询是否绑定手机
	    passportHasMobile: function passportHasMobile(data, fn) {
	        var _this = this;
	        var params = {
	            passport: data.passport,
	            uid: data.uid
	        };
	
	        proxy('passportHasMobile', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //获取已登录用户信息
	    getUserInfo: function getUserInfo(fn) {
	        var _this = this;
	        proxy('getUserInfo', '', function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //通过uid获取用户信息
	    getByFocusId: function getByFocusId(uid, fn) {
	        var _this = this;
	        var params = {
	            id: uid
	        };
	
	        proxy('getByFocusId', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //成功登陆用户绑定手机号
	    bindMobile: function bindMobile(mobile, captcha, source, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile,
	            captcha: captcha,
	            source: source //0是wap（默认），1是PC
	        };
	
	        proxy('bindMobile', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //判断原始绑定手机号是否正确
	    verifyOriginalBind: function verifyOriginalBind(mobile, captcha, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile,
	            captcha: captcha
	        };
	
	        proxy('verifyOriginalBind', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //修改绑定手机
	    modifyBind: function modifyBind(mobile, captcha, token, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile,
	            captcha: captcha,
	            token: token
	        };
	
	        proxy('modifyBind', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //获取图形验证码
	    getCaptcha: function getCaptcha(fn) {
	        var _this = this;
	        proxy('getCaptcha', '', function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //验证码认证
	    verifyCaptcha: function verifyCaptcha(input, fn) {
	        var _this = this;
	        var params = {
	            input: input
	        };
	
	        proxy('verifyCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //判断是否需要验证码
	    isNeeded: function isNeeded(input, fn) {
	        var _this = this;
	        proxy('isNeeded', '', function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //获取短信验证码
	    getMobileCaptcha: function getMobileCaptcha(data, fn) {
	        var _this = this;
	        var params = {
	            mobile: data.mobile, //s
	            type: data.type, //s；1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
	            imgcode: data.imgcode, //r
	            channel: data.channel, //r;用户中心传5，生态传12
	            cacode: data.cacode || ''
	        };
	
	        proxy('getMobileCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    // 获取短信验证码 add 腾讯验证
	    getMobileCaptchaTx: function getMobileCaptchaTx(data, fn) {
	        var _this = this;
	        var params = {
	            mobile: data.mobile, // s
	            type: data.type, // s；1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
	            ticket: data.ticket, // r
	            randstr: data.randstr,
	            channel: data.channel, // r;用户中心传5，生态传12
	            smsType: data.smsType || '', // 语音验证码传2
	            cacode: data.cacode || '',
	            token: window.fclogin_focus_token || null
	        };
	
	        proxy('getMobileCaptchaTx', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //获取邮箱验证
	    sendEmailCaptcha: function sendEmailCaptcha(email, type, fn) {
	        var _this = this;
	        var params = {
	            email: email,
	            type: type //验证码类型,1:注册
	        };
	
	        proxy('sendEmailCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //短信验证校验码
	    vertifyMobileCaptcha: function vertifyMobileCaptcha(mobile, captcha, type, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile,
	            type: type, //1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
	            captcha: captcha
	        };
	
	        proxy('vertifyMobileCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //通过旧密码修改新密码
	    modifyWithOldPwd: function modifyWithOldPwd(oldPwd, newPwd, fn) {
	        var _this = this;
	        var params = {
	            oldPwd: oldPwd, //s
	            newPwd: newPwd //s
	        };
	
	        proxy('modifyWithOldPwd', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //验证旧密码
	    verifyOldPwd: function verifyOldPwd(oldPwd, fn) {
	        var _this = this;
	        var params = {
	            oldPwd: oldPwd // s
	        };
	
	        proxy('verifyOldPwd', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //手机号重置密码
	    resetByMobile: function resetByMobile(token, password, fn) {
	        var _this = this;
	        var params = {
	            token: token, // s;第一步验证手机验证码接口返回
	            password: password // s;新密码
	        };
	
	        proxy('resetByMobile', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //邮箱重置密码
	    resetByEmail: function resetByEmail(token, password, fn) {
	        var _this = this;
	        var params = {
	            token: token, // s;第二步页面埋下的token
	            password: password // s;新密码
	        };
	
	        proxy('resetByEmail', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //手机短信验证码确认
	    passwordVerifyCaptcha: function passwordVerifyCaptcha(mobile, captcha, cacode, fn) {
	        var _this = this;
	        var params = {
	            mobile: mobile, // s;
	            captcha: captcha, // s;
	            cacode: cacode || ''
	        };
	
	        proxy('passwordVerifyCaptcha', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    },
	    //发送邮件
	    sendVerifyEmail: function sendVerifyEmail(userName, source, fn) {
	        var _this = this;
	        var params = {
	            userName: userName, // s;邮箱
	            source: source // s;0是wap 1是pc(默认)
	        };
	
	        proxy('sendVerifyEmail', params, function (res) {
	            if (typeof fn === 'function') {
	                fn(res);
	            }
	        });
	    }
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(3);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		var fnAddHeaders = function (headers, xmlhttp) {
		    var key, val;
		    for (key in headers) {
		        if (!headers.hasOwnProperty(key)) {
		            continue;
		        }
		        val = headers[key];
		        xmlhttp.setRequestHeader(key, val);
		    }
		};
	
		var fnIsCrossDomain = function (url) {
		    if (url.match(/^\/\//)) {
		        url = window.location.protocol + url;
		    }
	
		    var rurl = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
		    var ajaxLocParts = rurl.exec(window.location.href.toLowerCase()) || [];
		    var parts = rurl.exec(url.toLowerCase());
	
		    return crossDomain = !!(
		        parts &&
		            (parts[1] !== ajaxLocParts[1] ||
		              parts[2] !== ajaxLocParts[2] ||
		              (parts[3] ||
		                (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] ||
		                  (ajaxLocParts[1] === "http:" ? "80" : "443")))
		    );
		};
	
		// url {String}
		// method {String}
		// headers {Object}
		// body {String}
		// credentials {Boolean}
		// complete {Function}
		var fnXmlHttpRequest = function (url, method, headers, body, credentials, complete) {
		    var fnFormatParams = function () {
		        var fnFormatHeaders = function () {
		            // header
		            if (headers instanceof Object !== true) {
		                headers = {};
		            }
	
		            // X-Requested-With
		            if (fnIsCrossDomain(url) !== true) {
		                headers['X-Requested-With'] = 'XMLHttpRequest';
		            }
	
		            // Accept
		            headers.Accept = typeof headers.Accept !== 'string' ? '*/*' : headers.Accept;
		        };
	
		        if (typeof url !== 'string' || url === '') {
		            url = window.location.href;
		        }
	
		        if (typeof method !== 'string') {
		            method = 'GET';
		        }
	
		        fnFormatHeaders();
	
		        credentials = (fnIsCrossDomain(url) === true && credentials === true) ? true : false ;
	
		        body = typeof body === 'string' ? body : '';
		    };
	
		    var fn = function () {
				// alert(JSON.stringify(this))
	
		        if (this.readyState === 3) {
		            this.responseHeader = this.getAllResponseHeaders();
		        }
		        if (this.readyState === 4) {
		            if (typeof complete === 'function') {
		                complete(this);
		            }
		        }
		    };
	
		    fnFormatParams();
	
		    var xmlhttp = new XMLHttpRequest();
		    xmlhttp.onreadystatechange = fn;
		    xmlhttp.open(method, url, true);
		    fnAddHeaders(headers, xmlhttp);
		    xmlhttp.withCredentials = credentials;
		    xmlhttp.send(body);
		};
	
	
		exports.ajax = fnXmlHttpRequest;
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		var separator = '[[[SP]]]';
	
	
		var callbackStorage = {};
	
	
		var Messager = {};
	
	
		Messager.createListener = function (target) {
		    var callback = function (msg) {
		        if (typeof msg !== 'object') {
		            return;
		        }
	
		        // 验证是否是匹配的信息
		        msg = typeof msg.data === 'string' ? msg.data : '';
		        msg = msg.split(separator);
		        if (msg.length !== 2) {
		            return;
		        }
	
		        // 执行用户自定义回调
		        callbackStorage[msg[0]] = callbackStorage[msg[0]] || [];
		        var fns = callbackStorage[msg[0]];
		        var i;
		        for (i = 0; i < fns.length; i++) {
		            fns[i](msg[1]);
		        }
		    };
	
		    if ('addEventListener' in window.document) {
		        target.addEventListener('message', callback, false);
		    } else if ('attachEvent' in document) {
		        target.attachEvent('onmessage', callback);
		    }
		};
	
	
		Messager.listen = function (category, fn) {
		    callbackStorage[category] = callbackStorage[category] || [];
		    if (typeof fn === 'function') {
		        callbackStorage[category].push(fn);
		    }
		};
	
	
		Messager.post = function (target, category, msg) {
		    if (typeof msg !== 'string') {
		        console.log('msg should be string');
		        return;
		    }
		    target.postMessage(category + separator + msg, '*');
		};
	
	
		exports.Messager = Messager;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $$request = __webpack_require__(1);
		var $$requestIframe = __webpack_require__(4);
		var $$limit = __webpack_require__(5);
		var $$querystring = __webpack_require__(7);
		__webpack_require__(10);
	
	
		var request = {
		    // params {object}
		    // params.url {string}
		    // params.type {string}
		    // params.data {object}
		    // params.complete {function}
		    // params.contentType {string}
		    // params.withCredentials {boolean}
		    // params.cache {boolean}
		    ajax: function (params) {
		        params = $$limit.requestFormat(params);
	
		        var url = params.url;
		        var type = params.type;
		        var headers = {};
		        var body = '';
	
		        var fnInitParams = function () {
		            // type
		            var methods = [ 'GET', 'POST' ];
		            if (typeof params.type !== 'string' || methods.indexOf(params.type.toUpperCase()) < 0) {
		                params.type = 'GET';
		            }
	
		            // Content-Type
		            if (params.type === 'POST') {
		                if (typeof params.contentType === 'string' && params.contentType.indexOf('application/json') >= 0) {
		                    headers['Content-Type'] = 'application/json; charset=UTF-8';
		                } else {
		                    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		                }
		            }
	
		            // body
		            var paramsDataString = $$querystring.stringify(params.data);
		            if (params.type === 'GET') {
		                if (paramsDataString && paramsDataString !== '') {
		                    if (params.url.indexOf('?') >= 0) {
		                        url += '&' + paramsDataString;
		                    } else {
		                        url += '?' + paramsDataString;
		                    }
		                }
		            }
	
		            if (params.type === 'POST') {
		                if (typeof params.contentType === 'string' && params.contentType.indexOf('application/json') >= 0 ) {
		                    body = JSON.stringify(params.data);
		                } else {
		                    body = $$querystring.stringify(params.data);
		                }
		            }
	
		            // cache
		            if (params.cache !== false) {
		                if (url.indexOf('?') >= 0) {
		                    url += '&_t=' + (+new Date());
		                } else {
		                    url += '?_t=' + (+new Date());
		                }
		            }
		        };
		        fnInitParams();
	
		        var fn = function (xhr) {
		            var data;
	
		            if (!xhr || typeof xhr.responseText !== 'string') {
		                data = {
		                    code: 'LR-01',
		                    msg: '请求失败',
		                    data: {}
		                }
		                console.error('[LIB-REQUEST] [SERVER ERROR]');
		            } else {
		                try {
		                    data = JSON.parse(xhr.responseText);
		                } catch (e) {
		                    data = {
		                        code: 'LR-02',
		                        msg: 'JSON格式化错误',
		                        data: {}
		                    }
		                    console.error('[LIB-REQUEST] [PARSE JSON ERROR]');
		                }
		            }
	
		            if (typeof params.complete === 'function') {
		                data = $$limit.responseFormat(data);
		                params.complete(data);
		            }
		        };
	
		        var fnIsCrossDomain = function () {
		            if (url.match(/^\/\//)) {
		                url = window.location.protocol + url;
		            }
	
		            var rurl = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
		            var ajaxLocParts = rurl.exec(window.location.href.toLowerCase()) || [];
		            var parts = rurl.exec(url.toLowerCase());
	
		            return crossDomain = !!(
		                parts &&
		                    (parts[1] !== ajaxLocParts[1] ||
		                      parts[2] !== ajaxLocParts[2] ||
		                      (parts[3] ||
		                        (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] ||
		                          (ajaxLocParts[1] === "http:" ? "80" : "443")))
		            );
		        };
	
		        var isIframe = false;
		        if (fnIsCrossDomain()) {
		            if (window.navigator.userAgent.indexOf('MSIE 9.0') >= 0) {
		                isIframe = true;
		            }
		            if (window.navigator.userAgent.indexOf('MSIE 8.0') >= 0) {
		                isIframe = true;
		            }
		        }
		        if (isIframe) {
		            $$requestIframe.ajax(url, type, headers, body, params.withCredentials, fn);
		        } else {
		            $$request.ajax(url, type, headers, body, params.withCredentials, fn);
		        }
		    },
		    request: function (url, type, headers, body, withCredentials, fn) {
		        $$request.ajax(url, type, headers, body, withCredentials, fn);
		    },
		    requestByIframe: function (url, type, headers, body, withCredentials, fn) {
		        $$requestIframe.ajax(url, type, headers, body, withCredentials, fn);
		    },
		    pushWhiteList: function (url, key) {
		        $$limit.pushWhiteList(url, key);
		    },
		    pushParamsWhiteList: function (url, key) {
		        $$limit.pushParamsWhiteList(url, key);
		    }
		};
	
	
		module.exports = request;
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Messager = __webpack_require__(2).Messager;
	
		var fnGetMessager = (function () {
		    var messagerStorage = {};
	
		    var mapFnKeyStorage = {};
	
		    var messagerTag = Math.random();
	
		    var fnCreateIframe = function (domain) {
		        var protocol = window.location.protocol;
		        var iframe = window.document.createElement('iframe');
		        iframe.src = protocol + '//' + domain + '/crossdomain.html?tag=' + messagerTag;
		        iframe.style.display = 'none';
		        window.document.body.appendChild(iframe);
	
		        return iframe;
		    };
	
		    var fn = function (domain, fn) {
		        var messager = messagerStorage[domain] || {};
	
		        if (messager.ready === false) {
		            messager.readyFns = messager.readyFns || [];
		            messager.readyFns.push(fn);
		            return;
		        }
	
		        if (messager.ready === true) {
		            fn && fn(messager);
		            return;
		        }
	
		        // create messager
		        messager.frame = fnCreateIframe(domain);
		        messager.ready = false;
		        messager.readyFns = [ fn ];
		        messager.post = function (msg, fn) {
		            var key = 'key-' + (+new Date()) + window.Math.random().toFixed(15);
		            msg = key + ',' + encodeURIComponent(msg);
		            mapFnKeyStorage[key] = fn;
		            Messager.post(messager.frame.contentWindow, messagerTag + ',' + domain + ',' + 'child', msg);
		        };
		        messagerStorage[domain] = messager;
	
		        // listen
		        Messager.listen(messagerTag + ',' + domain + ',' + 'parent', function(msg) {
		            if (msg === '[[ready]]') {
		                messager.ready = true;
		                (function () {
		                    var i, fn;
		                    for (i = 0; i < messager.readyFns.length; i++) {
		                        fn = messager.readyFns[i];
		                        fn && fn(messager);
		                    }
		                }());
		            } else {
		                msg = msg.split(',');
		                mapFnKeyStorage[msg[0]] && mapFnKeyStorage[msg[0]](decodeURIComponent(msg[1]));
		            }
		        });
		    };
	
		    Messager.createListener(window);
	
		    return fn;
		}());
	
		var fnRequest = function (opt, fn) {
		    var domain = opt.url.match(/\/\/(.*?)\//);
		    if (domain) {
		        domain = domain[1];
		    } else {
		        domain = window.location.host;
		    }
	
		    fnGetMessager(domain, function (messager) {
		        var msg = JSON.stringify(opt);
	
		        messager.post(msg, function (msg) {
		            msg = JSON.parse(msg);
		            fn && fn(msg);
		        });
		    });
		};
	
		var fnAjax = function (url, method, headers, body, credentials, complete) {
		    var opt = {
		        url: url,
		        method: method,
		        headers: headers,
		        body: body,
		        credentials: credentials
		    };
	
		    fnRequest(opt, complete);
		};
	
		exports.ajax = fnAjax;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $$util = __webpack_require__(6);
		var $$querystring = __webpack_require__(7);
		var responseWhiteList = {};
		var requestWhiteList = {};
	
	
		var limit = {
		    requestFormat: function (params) {
		        var fnValidateQueryString = function (data) {
		            var fnValidate = function (key, val) {
		                var msg = '[LIB-REQUEST] [REQUEST FEILD ERROR] [' + key + ': ' + val + ']';
	
		                if (val instanceof Object === true) {
		                    console.error(msg);
		                    return false;
		                }
	
		                if (typeof val !== 'string') {
		                    val = JSON.stringify(val) || '';
		                }
	
		                while (val.indexOf('%') >= 0) {
		                    try {
		                        val = decodeURIComponent(val);
		                    } catch(e) {
		                        break;
		                    }
		                }
	
		                try {
		                    val = JSON.parse(val);
		                    if (val instanceof Object === true) {
		                        console.error(msg);
		                        return false;
		                    }
		                } catch (e) {}
	
		                return true;
		            };
	
		            var formatMap = {};
		            var key, val;
		            for (key in data) {
		                if (!data.hasOwnProperty(key)) {
		                    continue;
		                }
		                val = data[key];
		                if (fnValidate(key, val) === true) {
		                    formatMap[key] = val;
		                }
		            }
	
		            return formatMap;
		        };
	
		        var fnValidateUrl = function (url) {
		            if (typeof url !== 'string' || url === '') {
		                url = window.location.href;
		            }
	
		            var qs = url.split('?')[1];
		            var obj = $$querystring.parse(qs);
		            qs = $$querystring.stringify(fnValidateQueryString(obj));
		            if (qs && qs !== '') {
		                return url.split('?')[0] + '?' + qs;
		            } else {
		                return url.split('?')[0];
		            }
		        };
	
		        var fnValidateJson = function (data) {
		            if (data instanceof Object === false) {
		                return {};
		            }
	
		            var fnWalkObject, fnWalkArray;
	
		            fnWalkArray = function (array) {
		                var tbasic = false;
		                var tobject = false;
		                var isOneKeyObject = true;
	
		                $$util.arrayClear(array);
	
		                array.forEach(function (item, i) {
		                    var it = $$util.type(item);
		                    if (it === 'array') {
		                        array[i] = '[LIB-REQUEST] [REQUEST ARRAY ERROR]';
		                        return;
		                    }
		                    if (it === 'object') {
		                        tobject = true;
		                        if ($$util.getObjectKeys(item).length > 1) {
		                            isOneKeyObject = false;
		                        }
		                        return;
		                    }
		                    tbasic = true;
		                });
	
		                if (tbasic === true && tobject === true) {
		                    array = '[LIB-REQUEST] [REQUEST ARRAY ERROR]';
		                    return;
		                }
	
		                if (tobject === true && array.length > 0 && isOneKeyObject === true) {
		                    (function () {
		                        var key = $$util.getObjectKeys(array[0])[0];
		                        array.forEach(function (item, i) {
		                            array[i] = item[key];
		                        });
		                    }());
		                    return;
		                }
	
		                if (tobject === true && array.length > 0 && isOneKeyObject === false) {
		                    array.forEach(function (item) {
		                        fnWalkObject(item);
		                    });
		                }
		            };
	
		            fnWalkObject = function (object) {
		                var key, val, vt;
		                for (key in object) {
		                    if (!object.hasOwnProperty(key)) {
		                        continue;
		                    }
		                    val = object[key];
		                    vt = $$util.type(val);
		                    if (vt === 'object') {
		                        if (val === null) {
		                            delete object[key];
		                        } else if ($$util.isEmptyObject(val)) {
		                            delete object[key];
		                        } else {
		                            fnWalkObject(val);
		                        }
		                    } else if (vt === 'array') {
		                        fnWalkArray(val);
		                    } else if (vt === 'undefined') {
		                        delete object[key];
		                    }
		                }
		            };
	
		            fnWalkObject(data);
	
		            return data;
		        };
	
		        // url
		        params.url = fnValidateUrl(params.url);
	
		        // data
		        if (params.type === 'POST' && params.contentType === 'application/json') {
		            params.data = fnValidateJson(params.data);
		        } else {
		            params.data = fnValidateQueryString(params.data);
		        }
	
		        return params;
		    },
		    responseFormat: function (data) {
		        var fnValidateStructure = function (data) {
		            var msg = '[LIB-REQUEST] [RESPONSE STRUCTURE ERROR]';
		            var vdata = {
		                code: 'LR-03',
		                msg: msg,
		                data: {}
		            };
	
		            if (data instanceof Object === false) {
		                data = vdata;
		            }
	
		            var ctype = $$util.type(data.code);
		            var mtype = $$util.type(data.msg);
		            var dtype = $$util.type(data.data);
	
		            var pass = true;
	
		            if (['number', 'string'].indexOf(ctype) < 0) {
		                data.code = vdata.code;
		                pass = false;
		            }
		            if (['string'].indexOf(mtype) < 0) {
		                data.msg = vdata.msg;
		                pass = false;
		            }
		            if (['number', 'boolean', 'string', 'array', 'object'].indexOf(dtype) < 0) {
		                data.data = vdata.data;
		                pass = false;
		            }
	
		            return data;
		        };
	
		        var fnProcessApi = function (data) {
		            if (data instanceof Object === false) {
		                return {};
		            }
	
		            var fnWalkObject, fnWalkArray;
	
		            fnWalkArray = function (array) {
		                var tbasic = false;
		                var tobject = false;
		                var tarray = false;
		                var isOneKeyObject = true;
	
		                $$util.arrayClear(array);
	
		                array.forEach(function (item, i) {
		                    var it = $$util.type(item);
		                    if (it === 'array') {
		                        array[i] = '[LIB-REQUEST] [RESPONSE ARRAY ERROR]';
		                        return;
		                    }
		                    if (it === 'object') {
		                        tobject = true;
		                        if ($$util.getObjectKeys(item).length > 1) {
		                            isOneKeyObject = false;
		                        }
		                        return;
		                    }
		                    tbasic = true;
		                });
	
		                if (tbasic === true && tobject === true) {
		                    array = '[LIB-REQUEST] [RESPONSE ARRAY ERROR]';
		                    return;
		                }
	
		                // one key
		                if (tobject === true && array.length > 0 && isOneKeyObject === true) {
		                    (function () {
		                        var key = $$util.getObjectKeys(array[0])[0];
		                        array.forEach(function (item, i) {
		                            array[i] = item[key];
		                        });
		                    }());
		                    return;
		                }
	
		                // basic
		                if (tbasic === true && tobject === false) {
		                    array.forEach(function (item, i) {
		                        array[i] = item.toString();
		                    });
		                    return;
		                }
	
		                // object
		                if (tobject === true && array.length > 0 && isOneKeyObject === false) {
		                    array.forEach(function (item) {
		                        fnWalkObject(item);
		                    });
		                }
		            };
	
		            fnWalkObject = function (object) {
		                var key, val, vt;
		                for (key in object) {
		                    if (!object.hasOwnProperty(key)) {
		                        continue;
		                    }
		                    val = object[key];
		                    vt = $$util.type(val);
		                    if (vt === 'object') {
		                        if (val === null) {
		                            delete object[key];
		                        } else if ($$util.isEmptyObject(val)) {
		                            delete object[key];
		                        } else {
		                            fnWalkObject(val);
		                        }
		                    } else if (vt === 'array') {
		                        fnWalkArray(val);
		                    } else if (vt === 'undefined') {
		                        delete object[key];
		                    } else {
		                        try {
		                            object[key] = val.toString();
		                        } catch (e) {}
		                    }
		                }
		            };
	
		            fnWalkObject(data);
	
		            return data;
		        };
	
		        data = fnValidateStructure(data);
		        data = fnProcessApi(data);
	
		        return data;
		    },
		    pushWhiteList: function (url, key) {
		        if (typeof url !== 'string' || url === '') {
		            return;
		        }
		        if (typeof key !== 'string' || key === '') {
		            return;
		        }
		        responseWhiteList[url] = responseWhiteList[url] || [];
		        responseWhiteList[url].push(key);
		    },
		    pushParamsWhiteList: function (url, key) {
		        if (typeof url !== 'string' || url === '') {
		            return;
		        }
		        if (typeof key !== 'string' || key === '') {
		            return;
		        }
		        requestWhiteList[url] = requestWhiteList[url] || [];
		        requestWhiteList[url].push(key);
		    }
		};
	
	
		module.exports = limit;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		exports.type = function (val) {
		    var t = typeof val;
		    if (t === 'object' && val instanceof Array === true) {
		        t = 'array';
		    }
		    return t;
		};
	
		exports.isEmptyObject = function (object) {
		    var _this = this;
		    if (_this.type(object) !== 'object') {
		        return false;
		    }
	
		    var key;
		    for (key in object) {
		        if (object.hasOwnProperty(key)) {
		            return false;
		        }
		    }
		    return true;
		};
	
		exports.arrayClear = function (array, val) {
		    var _this = this;
		    var cnt = 0;
		    var i, item;
		    var match;
		    var i1;
		    for (i = 0; i < array.length; i++) {
		        match = false;
		        item = array[i];
		        if (item === null) {
		            match = true;
		        } else if (item === undefined) {
		            match = true;
		        } else if (_this.type(item) === 'object' && JSON.stringify(item) === '{}') {
		            match = true;
		        }
	
		        if (match) {
		            for (i1 = i; i1 < array.length; i1++) {
		                array[i1] = array[i1 + 1];
		            }
		            array.length = array.length - 1;
		        }
		    }
		};
	
		exports.getObjectKeys = function (object) {
		    var akey = [];
		    var key;
		    for (key in object) {
		        if (object.hasOwnProperty(key)) {
		            akey.push(key);
		        }
		    }
		    return akey;
		};
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.decode = exports.parse = __webpack_require__(8);
		exports.encode = exports.stringify = __webpack_require__(9);
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		'use strict';
	
		// If obj.hasOwnProperty has been overridden, then calling
		// obj.hasOwnProperty(prop) will break.
		// See: https://github.com/joyent/node/issues/1707
		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		}
	
		module.exports = function(qs, sep, eq, options) {
		  sep = sep || '&';
		  eq = eq || '=';
		  var obj = {};
	
		  if (typeof qs !== 'string' || qs.length === 0) {
		    return obj;
		  }
	
		  var regexp = /\+/g;
		  qs = qs.split(sep);
	
		  var maxKeys = 1000;
		  if (options && typeof options.maxKeys === 'number') {
		    maxKeys = options.maxKeys;
		  }
	
		  var len = qs.length;
		  // maxKeys <= 0 means that we should not limit keys count
		  if (maxKeys > 0 && len > maxKeys) {
		    len = maxKeys;
		  }
	
		  for (var i = 0; i < len; ++i) {
		    var x = qs[i].replace(regexp, '%20'),
		        idx = x.indexOf(eq),
		        kstr, vstr, k, v;
	
		    if (idx >= 0) {
		      kstr = x.substr(0, idx);
		      vstr = x.substr(idx + 1);
		    } else {
		      kstr = x;
		      vstr = '';
		    }
	
		    k = decodeURIComponent(kstr);
		    v = decodeURIComponent(vstr);
	
		    if (!hasOwnProperty(obj, k)) {
		      obj[k] = v;
		    } else if (isArray(obj[k])) {
		      obj[k].push(v);
		    } else {
		      obj[k] = [obj[k], v];
		    }
		  }
	
		  return obj;
		};
	
		var isArray = Array.isArray || function (xs) {
		  return Object.prototype.toString.call(xs) === '[object Array]';
		};
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		'use strict';
	
		var stringifyPrimitive = function(v) {
		  switch (typeof v) {
		    case 'string':
		      return v;
	
		    case 'boolean':
		      return v ? 'true' : 'false';
	
		    case 'number':
		      return isFinite(v) ? v : '';
	
		    default:
		      return '';
		  }
		};
	
		module.exports = function(obj, sep, eq, name) {
		  sep = sep || '&';
		  eq = eq || '=';
		  if (obj === null) {
		    obj = undefined;
		  }
	
		  if (typeof obj === 'object') {
		    return map(objectKeys(obj), function(k) {
		      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
		      if (isArray(obj[k])) {
		        return map(obj[k], function(v) {
		          return ks + encodeURIComponent(stringifyPrimitive(v));
		        }).join(sep);
		      } else {
		        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
		      }
		    }).join(sep);
	
		  }
	
		  if (!name) return '';
		  return encodeURIComponent(stringifyPrimitive(name)) + eq +
		         encodeURIComponent(stringifyPrimitive(obj));
		};
	
		var isArray = Array.isArray || function (xs) {
		  return Object.prototype.toString.call(xs) === '[object Array]';
		};
	
		function map (xs, f) {
		  if (xs.map) return xs.map(f);
		  var res = [];
		  for (var i = 0; i < xs.length; i++) {
		    res.push(f(xs[i], i));
		  }
		  return res;
		}
	
		var objectKeys = Object.keys || function (obj) {
		  var res = [];
		  for (var key in obj) {
		    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
		  }
		  return res;
		};
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		/*---------------------------------------*
		* Array
		*---------------------------------------*/
		(function (ap) {
		    // indexOf
		    if (ap.indexOf) {
		        return;
		    }
	
		    ap.indexOf = function (val) {
		        var i, item;
		        for (i = 0; i < this.length; i++) {
		            item = this[i];
		            if (val === item) {
		                break;
		            }
		        }
	
		        if (i < this.length) {
		            return i;
		        } else {
		            return -1;
		        }
		    };
	
		    // forEach
		    if (ap.forEach) {
		        return;
		    }
	
		    ap.forEach = function (fn) {
		        if (typeof fn !== 'function') {
		            return;
		        }
	
		        var i, item;
		        for (i = 0; i < this.length; i++) {
		            item = this[i];
		            fn.call(this, item, i);
		        }
		    };
		}(Array.prototype));
	
	
	/***/ }
	/******/ ])
	});
	;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _passportAdapter = __webpack_require__(42);
	
	var hostArr = location.hostname.split('.');
	var hostName = hostArr[hostArr.length - 2];
	
	var domain;
	if (/focus\.cn/.test(location.host)) {
	    domain = '//login.' + 'focus.cn/';
	} else if (/focustest\.cn/.test(location.host)) {
	    domain = '//login.focustest.cn/';
	} else {
	    var matched = location.host.match(/focus-(.*)\.cn/);
	    if (matched && matched.length && matched[1]) {
	        domain = '//login.focus-' + matched[1] + '.cn/';
	    } else {
	        domain = '//' + location.host + '/';
	    }
	}
	
	var mock = false;
	
	var proxy = function proxy(resourceName, data, fn) {
	
	    $.ajax({
	        url: domain + (mock ? 'mock/' : '') + _passportAdapter.apiAdapter[resourceName] + '?timestamp=' + new Date().getTime(),
	        data: data,
	        dataType: 'json',
	        type: mock ? 'get' : _passportAdapter.typeAdapter[resourceName],
	        async: true,
	        success: function success(res) {
	            fn(res);
	        }
	    });
	};
	module.exports = proxy;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var apiAdapter = {
	    'regByEmail': 'reg/regByEmail',
	    'regByMobile': 'reg/regByMobileCaptcha',
	    'loginByCaptcha': 'login/imgControl/loginByCaptcha',
	    'loginByPassport': 'login/loginByPassport',
	    'mobileHasBind': 'passport/hasMobile',
	    'getUserInfo': 'passport/getUserInfo',
	    'passportHasMobile': 'passport/hasMobile',
	    'regCheck': 'passport/regCheck',
	    'modifyBind': 'mobile/modifyBind',
	    'bindMobile': 'mobile/bindMobile',
	    'sendEmailCaptcha': 'mobile/modifyBind',
	    'verifyOriginalBind': 'mobile/verifyOriginalBind',
	    'vertifyMobileCaptcha': 'captcha/vertifyMobileCaptcha',
	    'getMobileCaptcha': 'captcha/secure/getMobileCaptcha',
	    'getMobileCaptchaTx': 'captcha/secure/tx/getMobileCaptcha',
	    'getCaptcha': 'imgcode/getCaptcha',
	    'verifyCaptcha': 'imgcode/verifycaptcha',
	    'isNeeded': 'imgcode/isNeeded',
	    'modifyWithOldPwd': 'password/modifyWithOldPwd',
	    'verifyOldPwd': 'password/modifyWithOldPwd',
	    'resetByMobile': 'password/resetByMobile',
	    'resetByEmail': 'password/resetByEmail',
	    'passwordVerifyCaptcha': 'password/verifyCaptcha',
	    'sendVerifyEmail': 'password/sendVerifyEmail'
	};
	
	exports.apiAdapter = apiAdapter;
	var typeAdapter = {
	    'regByEmail': 'post',
	    'regByMobile': 'post',
	    'loginByCaptcha': 'post',
	    'loginByPassport': 'post',
	    'mobileHasBind': 'get',
	    'getUserInfo': 'get',
	    'passportHasMobile': 'get',
	    'regCheck': 'get',
	    'modifyBind': 'post',
	    'bindMobile': 'post',
	    'sendEmailCaptcha': 'post',
	    'verifyOriginalBind': 'post',
	    'vertifyMobileCaptcha': 'post',
	    'getMobileCaptcha': 'get',
	    'getCaptcha': 'get',
	    'verifyCaptcha': 'post',
	    'isNeeded': 'get'
	};
	exports.typeAdapter = typeAdapter;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var rotateLeft = function(lValue, iShiftBits) {
	        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
	    }
	    var addUnsigned = function(lX, lY) {
	        var lX4, lY4, lX8, lY8, lResult;
	        lX8 = (lX & 0x80000000);
	        lY8 = (lY & 0x80000000);
	        lX4 = (lX & 0x40000000);
	        lY4 = (lY & 0x40000000);
	        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
	        if (lX4 & lY4) return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
	        if (lX4 | lY4) {
	            if (lResult & 0x40000000) return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
	            else return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
	        } else {
	            return (lResult ^ lX8 ^ lY8);
	        }
	    }
	    var F = function(x, y, z) {
	        return (x & y) | ((~x) & z);
	    }
	    var G = function(x, y, z) {
	        return (x & z) | (y & (~z));
	    }
	    var H = function(x, y, z) {
	        return (x ^ y ^ z);
	    }
	    var I = function(x, y, z) {
	        return (y ^ (x | (~z)));
	    }
	    var FF = function(a, b, c, d, x, s, ac) {
	        a = addUnsigned(a, addUnsigned(addUnsigned(F(b, c, d), x), ac));
	        return addUnsigned(rotateLeft(a, s), b);
	    };
	    var GG = function(a, b, c, d, x, s, ac) {
	        a = addUnsigned(a, addUnsigned(addUnsigned(G(b, c, d), x), ac));
	        return addUnsigned(rotateLeft(a, s), b);
	    };
	    var HH = function(a, b, c, d, x, s, ac) {
	        a = addUnsigned(a, addUnsigned(addUnsigned(H(b, c, d), x), ac));
	        return addUnsigned(rotateLeft(a, s), b);
	    };
	    var II = function(a, b, c, d, x, s, ac) {
	        a = addUnsigned(a, addUnsigned(addUnsigned(I(b, c, d), x), ac));
	        return addUnsigned(rotateLeft(a, s), b);
	    };
	    var convertToWordArray = function(string) {
	        var lWordCount;
	        var lMessageLength = string.length;
	        var lNumberOfWordsTempOne = lMessageLength + 8;
	        var lNumberOfWordsTempTwo = (lNumberOfWordsTempOne - (lNumberOfWordsTempOne % 64)) / 64;
	        var lNumberOfWords = (lNumberOfWordsTempTwo + 1) * 16;
	        var lWordArray = Array(lNumberOfWords - 1);
	        var lBytePosition = 0;
	        var lByteCount = 0;
	        while (lByteCount < lMessageLength) {
	            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
	            lBytePosition = (lByteCount % 4) * 8;
	            lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
	            lByteCount++;
	        }
	        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
	        lBytePosition = (lByteCount % 4) * 8;
	        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
	        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
	        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
	        return lWordArray;
	    };
	    var wordToHex = function(lValue) {
	        var WordToHexValue = "",
	        WordToHexValueTemp = "",
	        lByte, lCount;
	        for (lCount = 0; lCount <= 3; lCount++) {
	            lByte = (lValue >>> (lCount * 8)) & 255;
	            WordToHexValueTemp = "0" + lByte.toString(16);
	            WordToHexValue = WordToHexValue + WordToHexValueTemp.substr(WordToHexValueTemp.length - 2, 2);
	        }
	        return WordToHexValue;
	    };
	    var uTF8Encode = function(string) {
	        string = string.replace(/\x0d\x0a/g, "\x0a");
	        var output = "";
	        for (var n = 0; n < string.length; n++) {
	            var c = string.charCodeAt(n);
	            if (c < 128) {
	                output += String.fromCharCode(c);
	            } else if ((c > 127) && (c < 2048)) {
	                output += String.fromCharCode((c >> 6) | 192);
	                output += String.fromCharCode((c & 63) | 128);
	            } else {
	                output += String.fromCharCode((c >> 12) | 224);
	                output += String.fromCharCode(((c >> 6) & 63) | 128);
	                output += String.fromCharCode((c & 63) | 128);
	            }
	        }
	        return output;
	    };
	    var md5 = {
	        md5: function(string) {
	            var x = Array();
	            var k, AA, BB, CC, DD, a, b, c, d;
	            var S11 = 7,
	            S12 = 12,
	            S13 = 17,
	            S14 = 22;
	            var S21 = 5,
	            S22 = 9,
	            S23 = 14,
	            S24 = 20;
	            var S31 = 4,
	            S32 = 11,
	            S33 = 16,
	            S34 = 23;
	            var S41 = 6,
	            S42 = 10,
	            S43 = 15,
	            S44 = 21;
	            string = uTF8Encode(string);
	            x = convertToWordArray(string);
	            a = 0x67452301;
	            b = 0xEFCDAB89;
	            c = 0x98BADCFE;
	            d = 0x10325476;
	            for (k = 0; k < x.length; k += 16) {
	                AA = a;
	                BB = b;
	                CC = c;
	                DD = d;
	                a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
	                d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
	                c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
	                b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
	                a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
	                d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
	                c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
	                b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
	                a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
	                d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
	                c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
	                b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
	                a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
	                d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
	                c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
	                b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
	                a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
	                d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
	                c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
	                b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
	                a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
	                d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
	                c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
	                b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
	                a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
	                d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
	                c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
	                b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
	                a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
	                d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
	                c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
	                b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
	                a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
	                d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
	                c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
	                b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
	                a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
	                d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
	                c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
	                b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
	                a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
	                d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
	                c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
	                b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
	                a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
	                d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
	                c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
	                b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
	                a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
	                d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
	                c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
	                b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
	                a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
	                d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
	                c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
	                b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
	                a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
	                d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
	                c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
	                b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
	                a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
	                d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
	                c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
	                b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
	                a = addUnsigned(a, AA);
	                b = addUnsigned(b, BB);
	                c = addUnsigned(c, CC);
	                d = addUnsigned(d, DD);
	            }
	            var tempValue = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
	            return tempValue.toLowerCase();
	        }
	    };
	
	    module.exports = md5.md5;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Error = (function () {
	    function Error() {
	        _classCallCheck(this, Error);
	
	        this.ErrorTxt = ['请输入正确的手机号', '手机号格式错误', '请先获取验证码', '请输入手机短信中的验证码', '手机验证码已下发，请耐心等候！', '请输入正确的图片验证码', '请输入正确的手机验证码', '请输入正确的邮箱地址', '密码长度是8-16位', '密码格式不正确', '确认密码和密码不一致', '密码不能是纯数字', '请输入正确的邮箱地址', '请输入图片验证码', '确认密码不能为空', '密码强度太低'];
	    }
	
	    _createClass(Error, [{
	        key: 'show',
	        value: function show(obj, txt) {
	            var parent = obj.parents('dd');
	            if (parent.find('.span-error').length === 0) {
	                parent.append('<div class="span-error"></div>');
	            }
	            parent.find('.span-error').html(txt).show();
	        }
	    }, {
	        key: 'hide',
	        value: function hide(obj) {
	            var parent = obj.parents('dd');
	            if (parent.find('.span-error')) {
	                parent.find('.span-error').hide();
	            }
	        }
	    }]);
	
	    return Error;
	})();
	
	exports['default'] = Error;
	;
	module.exports = exports['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Validate = {
	    //判断是否为空
	    isEmpty: function isEmpty(string) {
	        if (string === '') {
	            return 1;
	        }
	        return 0;
	    },
	    isMobile: function isMobile(mobile) {
	        if (/^(13|14|15|17|18)[0-9]{9}$/.test(mobile)) {
	            return 1;
	        }
	        return 0;
	    },
	    isEmail: function isEmail(email) {
	        var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
	        if (re.test(email)) {
	            return 1;
	        }
	        return 0;
	    },
	    pwdLevel: function pwdLevel(password) {
	        var Modes = 0,
	            i;
	        var type = []; //存类型
	        function CharMode(iN) {
	            //数字
	            if (iN >= 48 && iN <= 57) {
	                if (type.indexOf('d') < 0) {
	                    type.push('d');
	                }
	                return 1;
	            }
	            //大小写字母
	            if (iN >= 97 && iN <= 122 || iN >= 65 && iN <= 90) {
	                if (type.indexOf('w') < 0) {
	                    type.push('w');
	                }
	                return 4;
	            } else {
	                //特殊字符
	                if (type.indexOf('o') < 0) {
	                    type.push('o');
	                }
	                return 8;
	            }
	        }
	        for (i = 0; i < password.length; i++) {
	            CharMode(password.charCodeAt(i));
	        }
	        return type;
	    }
	};
	
	exports.Validate = Validate;
	var mailMap = {
	    'qq.com': 'http://mail.qq.com',
	    'gmail.com': 'http://mail.google.com',
	    'sina.com': 'http://mail.sina.com.cn',
	    '163.com': 'http://mail.163.com',
	    '126.com': 'http://mail.126.com',
	    'yeah.net': 'http://www.yeah.net/',
	    'sohu.com': 'http://mail.sohu.com/',
	    'tom.com': 'http://mail.tom.com/',
	    'sogou.com': 'http://mail.sogou.com/',
	    '139.com': 'http://mail.10086.cn/',
	    'hotmail.com': 'http://www.hotmail.com',
	    'live.com': 'http://login.live.com/',
	    'live.cn': 'http://login.live.cn/',
	    'live.com.cn': 'http://login.live.com.cn',
	    '189.com': 'http://webmail16.189.cn/webmail/',
	    'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
	    'yahoo.cn': 'http://mail.cn.yahoo.com/',
	    'eyou.com': 'http://www.eyou.com/',
	    '21cn.com': 'http://mail.21cn.com/',
	    '188.com': 'http://www.188.com/',
	    'foxmail.coom': 'http://www.foxmail.com'
	};
	
	exports.mailMap = mailMap;
	var renderHtml = ['<dl class="clear"><dt>新 密 码</dt><dd class="long pwd-new-wrap"><input type="password" class="input tel" placeholder="8-16位字符(需包含大写字母、小写字母、数字以及特殊字符中的三种)" node-type="passport-pass1">' +
	// '<div class="safe-tip"><span>安全强度：</span><i class="low ">低</i><i class="mid ">中</i><i class="high ">高</i></div>' +
	'</dd></dl><dl class="clear"><dt>确认密码 </dt><dd class="pwd-cfm-wrap long">' + '<input type="password" class="input validate" name="validate" id="validate" placeholder="请再次输入密码" node-type="passport-pass2"></dd></dl><dl class="clear"><dt></dt>' + '<dd class="submit"><a class="submit-btn disabled" href="javascript:void(0)" next-step="13" node-type="mobile-step2">确定</a></dd></dl>', '<p class="tip mail-sended">验证邮件已发送</p><p class="tip-small">验证邮件已发送至您的邮箱<b class="sended-mail"></b>，点击邮件中的链接完成操作，验证邮件<b>24个小时</b>内有效，请尽快验证！</p>' + '<div class="btn-wrap"><a class="submit-btn goto-mail-btn" href="javascript:void(0)">立即前往验证</a> <span class="send-msg-wrap"></span></div>', '<p class="tip">密码设置成功</p>', ' <p class="tip tip-err">链接已失效</p><p class="tip-time-out send-msg-wrap">验证链接已失效，点击 <a class="resend" href="#">重新发送</a>'];
	exports.renderHtml = renderHtml;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	window.FCAbroadMobile.config({
	    ctn: inputWrap,
	    width: 100,
	    height: 40,
	    onChoose: function(val) {
	        console.log(val);
	    }
	})
	
	window.FCAbroadMobile.check()
	window.FCAbroadMobile.show()
	window.FCAbroadMobile.hide()
	window.FCAbroadMobile.onChoose = function() {
	
	}
	**/
	
	'use strict';
	
	window.FCAbroadMobile = function (cfg) {
	    this.curSelect = '+86';
	
	    this._cfg = {
	        domain: 'login',
	        ctn: 'inputCtn', //
	        width: 100, //
	        height: 40, //
	        itemHeight: 30,
	        itemNum: 7,
	        onChoose: null, //
	        disabled: false
	
	    };
	    this._cfg = $.extend({}, this._cfg, cfg);
	
	    this.init();
	};
	window.FCAbroadMobile.prototype = {
	
	    init: function init() {
	        var that = this;
	
	        var $ctn = typeof that._cfg.ctn === 'string' ? $(that._cfg.ctn) : that._cfg.ctn;
	        $ctn.css({
	            'position': 'relative',
	            'overflow': 'visible'
	        });
	
	        that.appendStyle(that._template(that.styleTxt, {
	            domain: that._cfg.domain,
	            height: that._cfg.height,
	            width: that._cfg.width,
	            pop_top: that._cfg.height - 1,
	            itemHeight: that._cfg.itemHeight,
	            input_width: that._cfg.width - 50,
	            max_pop_height: that._cfg.itemHeight * that._cfg.itemNum
	        }));
	
	        $ctn.html(that._template(that._tpl_input, {
	            domain: that._cfg.domain
	        }));
	
	        that.$el = $ctn.find('.FCMobile-wrap_' + that._cfg.domain);
	        that.$input = that.$el.find('.FCMobile-input');
	        that.$label = that.$el.find('.FCMobile-input-label');
	
	        if (that._cfg.disabled) {
	            that.$input.attr('disabled', true);
	        }
	
	        $.ajax({
	            url: '/captcha/cacode',
	            type: 'get',
	            success: function success(res) {
	                if (res.code == '200') {
	
	                    that.data = res.data;
	
	                    // 设置默认区码
	                    that.$el.find('.FCMobile-input-label').html('+' + res.data.defaultCACode.code);
	
	                    that._renderPop(res.data);
	
	                    that.$pop = that.$el.find('.FCMobile-pop');
	
	                    that._addEvt();
	                }
	            },
	            failure: function failure(res) {}
	
	        });
	    },
	
	    _addEvt: function _addEvt() {
	        var that = this;
	        that.$label.on('click', function () {
	            that.$pop.css('display') == 'none' ? that.show() : that.hide();
	        });
	
	        that.$el.on('click', '.FCMobile-item, .FCMobile-dft', function () {
	            that.curSelect = $(this).find('.FCMobile-item_right').html();
	
	            that.$el.find('.FCMobile-item').removeClass('cur');
	            $(this).addClass('cur');
	
	            that.$label.html(that.curSelect);
	
	            that.hide();
	
	            that.$input.trigger('FCMobile_SELECT', that.curSelect);
	        });
	    },
	
	    show: function show(cfg) {
	        this.$pop.slideDown();
	    },
	
	    hide: function hide(cfg) {
	        this.$pop.slideUp();
	    },
	
	    set: function set(code, mobile) {
	        if (code) {
	            this.curSelect = '+' + code;
	            this.$label.html(this.curSelect);
	        }
	
	        if (mobile) {
	            this.curSelectVal = mobile;
	            this.$input.val(this.curSelectVal);
	        }
	    },
	
	    getData: function getData() {},
	    getCode: function getCode() {
	        return this.$label.html().replace('+', '');
	    },
	
	    _renderPop: function _renderPop(data) {
	
	        this.$el.append(this._tpl_pop);
	
	        this.$el.find('.FCMobile-dft').html(this._template(this._tpl_item, data.defaultCACode));
	
	        if (this.curSelect == '+' + data.defaultCACode.code) {
	            this.$el.find('.FCMobile-dft').addClass('cur');
	        }
	
	        var tmp = [];
	        for (var i = 0; i < data.topCACodes.length; i++) {
	            var item = data.topCACodes[i];
	            var cur = false;
	
	            if (this.curSelect == '+' + item.code) {
	                cur = true;
	            }
	            tmp.push('<li class="FCMobile-item ' + (cur ? 'cur' : '') + '">' + this._template(this._tpl_item, item) + '</li>');
	        }
	        this.$el.find('.FCMobile-list').html(tmp.join(''));
	    },
	
	    check: function check() {
	        var pattern = this._patternMap[this.curSelect];
	
	        if (!this.$input.val()) {
	            return false;
	        }
	        if (!pattern) {
	            return true;
	        }
	        if (pattern.test(this.$input.val())) {
	            // console.log(pattern, 'true');
	            return true;
	        } else {
	            // console.log(pattern, 'false');
	            return false;
	        }
	    },
	
	    _patternMap: {
	        '+86': /^1[0-9]{10}$/,
	        '+1': /^\d{10}$/,
	        '+60': /^((0?10|0?12|0?13|0?14|0?16|0?17|0?18|0?19)\d{7})|(0?11\d{8})$/,
	        '+66': /^(0?)8[0-9]{8}$/,
	        '+61': /^(0?)4[0-9]{8}$/,
	        '+81': /^(0?70|0?80|0?90)[0-9]{8}$/,
	        '+44': /^(0?)7[0-9]{9}$/,
	        '+853': /^6[0-9]{7}$/,
	        '+852': /^[69][0-9]{7}$/
	    },
	
	    _template: function _template(template, data) {
	        // {a} b
	        var tokenReg = /\{\{([^\{\}\\]+)\}\}/g;
	
	        return template.replace(tokenReg, function ($, $1) {
	            return $.replace($, data[$1]);
	        });
	    },
	
	    _tpl_input: '\n    <div class="FCMobile-wrap_{{domain}}">\n        <div class="FCMobile-input-wrap">\n            <span class="FCMobile-input-label">+86</span>\n            <input class="FCMobile-input" placeholder="手机号码"></input>\n        </div>\n    </div>\n    ',
	
	    _tpl_pop: '\n        <div class="FCMobile-pop">\n            <div class="FCMobile-dft">\n\n            </div>\n            <ul class="FCMobile-list">\n\n            </ul>\n        </div>\n    ',
	
	    _tpl_item: '\n        <span class="FCMobile-item_left">{{nameZh}}</span>\n        <span class="FCMobile-item_right">+{{code}}</span>',
	
	    styleTxt: '\n\n        .FCMobile-wrap_{{domain}} {\n\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-input-wrap {\n            position: relative;\n            width: {{width}}px;\n            height: {{height}}px;\n            border: 1px solid #ddd;\n            line-height: {{height}}px;\n            box-sizing: border-box;\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-input-label {\n            position: absolute;\n            left: 0;\n            top: 0;\n            height: 100%;\n            padding: 0 10px;\n            cursor: pointer;\n            font-size: 14px;\n            color: #333;\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-input {\n            margin-left: 44px;\n            display: block;\n            width: {{input_width}}px;\n            height: 100%;\n            border: none;\n            text-indent: 15px;\n            font-size: 14px;\n            color: #333;\n        }\n\n        .FCMobile-wrap_{{domain}} .FCMobile-pop {\n            display: none;\n            position: absolute;\n            top: {{pop_top}}px;\n            width: 100%;\n            z-index: 999;\n            font-size: 12px;\n            color: #666;\n            background-color: #fff;\n            border: 1px solid #D8D8D8;\n            box-sizing: border-box;\n\n            max-height: {{max_pop_height}}px;\n            overflow: scroll;\n        }\n\n        .FCMobile-wrap_{{domain}} .FCMobile-list{\n\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-dft, .FCMobile-item{\n            height: {{itemHeight}}px;\n            line-height: {{itemHeight}}px;\n            padding: 0 28px 0 10px;\n            cursor: pointer;\n            text-align: left;\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-dft {\n            border-bottom: 1px solid #D8D8D8;\n\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-item.cur {\n            background: #F8F8F8;\n        }\n        .FCMobile-wrap_{{domain}} .FCMobile-item_right {\n            float: right;\n        }\n    ',
	
	    appendStyle: function appendStyle(str) {
	        var domainInit = 'FCAbroadMobile' + this._cfg.domain + '_inited';
	
	        if (!!window[domainInit]) {
	            return;
	        }
	
	        window[domainInit] = true;
	
	        var nod = document.createElement('style');
	        nod.type = 'text/css';
	        if (nod.styleSheet) {
	            //ie下
	            nod.styleSheet.cssText = str;
	        } else {
	            nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))
	        }
	        document.getElementsByTagName('head')[0].appendChild(nod);
	    }
	
	};
	// return; // 这期没存区号 所以可选

/***/ })
]);


// WEBPACK FOOTER //
// passport-password/passport-password.0055bf5d79dee16712ba.js